import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from '@shared/hooks';
import type { Consultation } from '@shared/types/consultations';

const consultationsAdapter = createEntityAdapter<Consultation>({});

const consultationsSlice = createSlice({
	name: 'consultations2',
	initialState: consultationsAdapter.getInitialState(),
	reducers: {
		consultationAdd: consultationsAdapter.addOne,
		consultationsAdd: consultationsAdapter.addMany,
		consultationsRemove: consultationsAdapter.removeAll,
		consultationRemove: consultationsAdapter.removeOne,
		consultationsSet: consultationsAdapter.setAll,
		consultationSet: consultationsAdapter.setOne,
		consultationUpdate: consultationsAdapter.updateOne,
	},
});

export const consultationsReducer = consultationsSlice.reducer;
export const consultationsActions = consultationsSlice.actions;

export const consultationsSelectors = consultationsAdapter.getSelectors();

export const useConsultation = (id: number) => {
	const dispatch = useAppDispatch();
	const consultation = useAppSelector((state) =>
		consultationsSelectors.selectById(state.consultations, id)
	);

	const updateConsultation = (id: number, changes: Partial<Consultation>) =>
		dispatch(consultationsActions.consultationUpdate({ id: id, changes: changes }));

	return {
		consultation,
		updateConsultation,
	};
};

export const useConsultations = () => {
	const dispatch = useAppDispatch();

	const addConsultations = (consultations: Consultation[]) =>
		dispatch(consultationsActions.consultationsAdd(consultations));

	const addConsultation = (consultation: Consultation) =>
		dispatch(consultationsActions.consultationAdd(consultation));

	const setConsultation = (consultation: Consultation) =>
		dispatch(consultationsActions.consultationSet(consultation));

	return {
		addConsultation,
		addConsultations,
		setConsultation,
	};
};
